<script>
import Validation from '@/plugins/validation'
import { InputWithObj, Select, CheckboxWithObj, Input, AutocompleteSelect, TextareaObj } from '@/components/formelements'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'PRetailer',
  props: ['id'],
  async mounted() {
    this.$store.dispatch('pretailer/RESET')
    await this.$store.dispatch('pretailer/SET_PRETAILER', this.id)
    await this.$store.dispatch('pretailer/GET_PRETAILER_TYPES')
    await this.$store.dispatch('pretailer/GET_DATA_SOURCE_TYPES')
    if (this.id != 0) await this.$store.dispatch('pretailer/GET_PRETAILER_BY_RETAILER_ID')
    this.$store.dispatch('pretailer/SET_FIELD', { key: 'storeSearchResults', value: [] })
    this.$store.dispatch('pretailer/SET_FIELD', { key: 'totalOnServer', value: -1 })
  },
  data() {
    return {
      ...Validation,
      activeTab: 'pretailer',
      selectedStore: '',
      searchCriteriaItems: [
        {
          text: 'Store Ref #',
          value: 'dataSourceKeySearch'
        },
        {
          text: 'Store ID',
          value: 'storeIDSearch'
        },
        {
          text: 'Store Name',
          value: 'storeNameSearch'
        },
        {
          text: 'Zip/Post Code',
          value: 'postalCodeSearch'
        },
        {
          text: 'City/State',
          value: 'citySearch'
        },
      ],
      statusDropdown: [
        {
          text: 'All',
          value: 'All Statuses'
        },
        {
          text: 'Active',
          value: 'Active'
        },
        {
          text: 'Deleted/Inactive',
          value: 'deleted/inactive'
        },
      ],
      tableLoading: false,
      storeDialog: false,
      siteDialog: false,
      newStore: false,
      disableSearch: false,
      disableCity: true,
      disableState: true,
      disableStatus: false,
      disableCountry: true,
      disableInputs: {
        dataSourceKeySearch: () => { this.disableSearch = false, this.disableCity = true, this.disableState = true, this.disableCountry = true, this.disableStatus = false  },
        storeIDSearch: () => { this.disableSearch = false, this.disableCity = true, this.disableState = true, this.disableCountry = true, this.disableStatus = true },
        storeNameSearch: () => { this.disableSearch = false, this.disableCity = false, this.disableState = false, this.disableCountry = false, this.disableStatus = false },
        postalCodeSearch: () => { this.disableSearch = false, this.disableCity = true, this.disableState = true, this.disableCountry = false, this.disableStatus = false },
        citySearch: () => { this.disableSearch = false, this.disableCity = true, this.disableState = false, this.disableCountry = false, this.disableStatus = false },
      },
  
    }
  },
  components: {
    InputWithObj,
    CheckboxWithObj,
    Select,
    Input,
    AutocompleteSelect,
    TextareaObj
  },
  computed: {
    ...mapState({
      retailerType: state => state.retailer.retailerType,
      statusTypes: state => state.search.statusTypes,
      statesAPI: state => state.merchant.states,
      countries: state => state.merchant.countries,
      pretailerInfo: state => state.pretailer.pretailerInfo,
      storeSearchResults: state => state.pretailer.storeSearchResults,
      storeSearchCriteria: state => state.pretailer.storeSearchCriteria,
      allLanguages: state => state.retailerTag.allLanguages,
      siteTypes: state => state.siteFilter.siteTypes,
    }),
    ...mapGetters({
      pretailerTypes: 'pretailer/pretailerTypes',
      dataSourceTypes: 'pretailer/dataSourceTypes',
      pretailerByRetailer: 'pretailer/pretailerByRetailer',
      siteSearchResults: 'pretailer/siteSearchResults'
    }),
    siteTypeItems: function() {
      const eligibleSiteTypes =  this.siteTypes.filter( type => type.EligibleForRetailer == "true")
      return eligibleSiteTypes.map( type => {
        return { text: type.Name, value: type.ID }
      })
    },
    allLanguagesItems(){
      return this.allLanguages.map( lang => {
        return { text: lang.Name, value: lang.ID }
      })
    },
    statesItems(){
      return this.statesAPI.map( state => {
        return { text: state.Name, value: state.Code }
      })
    },
    countriesItems() {
      return this.countries.map( country => {
        return { text: country.Abbreviation, value: country.ID }
      })
    },
    retailerTypeItems() {
      return this.retailerType.map( type => {
        return { text: type.Name, value: type.ID }
      })
    },
    getRowStatus: function() {
      if (!this.pretailerInfo.RowStatus) return 'Active'
      const status = this.statusTypes.filter( type => type.ID == this.pretailerInfo.RowStatus )
      return status[0].Name
    },
  },
  watch: {
    storeSearchCriteria(newVal){
      this.disableInputs[newVal]()
      this.searchCriteriaItems.forEach( item => {
        this.$store.dispatch('pretailer/SET_FIELD', { key: item.value, value: '' })
      })
      this.$store.dispatch('pretailer/SET_FIELD', { key: 'storeSearchState', value: '' })
      this.$store.dispatch('pretailer/SET_FIELD', { key: 'storeSearchCounty', value: '1' })
      this.$store.dispatch('pretailer/SET_FIELD', { key: 'storeSearchStatus', value: 'All Statuses' })
    }
  },
  methods: {
    getTabelRowStatus: function(statusCode) {
      const status = this.statusTypes.filter( type => type.ID == statusCode)
      if (status.length == 0) return ''
      return status[0].Name
    },
    siteSearchHeaders() {
      return [
        {
          text: 'Attached',
          value: 'IsAttachedToSite'
        },
        {
          text: 'Site ID',
          value: 'ID'
        },
        {
          text: 'Site Code',
          value: 'Code'
        }
      ]
    },
    headers(){
      return [
        {
          text: 'Store Reference',
          value: 'Reference'
        },
        {
          text: 'Store Name',
          value: 'Name'
        },
        {
          text: 'Address 1',
          value: 'Address1'
        },
        {
          text: 'City',
          value: 'City'
        },
        {
          text: 'State',
          value: 'State'
        },
        {
          text: 'Zip',
          value: 'ZipCode5'
        },
        {
          text: 'Open Date',
          value: 'OpenDate'
        },
        {
          text: 'Close Date',
          value: 'CloseDate'
        },
        {
          text: 'Data Source Key',
          value: 'DataSourceKey'
        },
        {
          text: 'Store ID',
          value: 'ID'
        },
        {
          text: 'Status',
          value: 'RowStatus'
        },
      ]
    },
    async saveUpdates(){
      if(this.$refs.updateRetailerForm.validate()) {
        if (this.id == 0){
          await this.$store.dispatch('retailer/INSERT_RETAILER')
          this.$router.push({name: 'Retailer', params: { id: this.retailerInfo.ID }})
        } else {
          await this.$store.dispatch('retailer/UPDATE_RETAILER')
        }
      }
    },
    newStoreBtn() {
      this.newStore = true
      this.$store.dispatch('pretailer/RESET_STORE')
      this.storeDialog = true
    },
    async searchStore(){
      this.tableLoading = true
      await this.$store.dispatch('pretailer/SEARCH_STORE', { recordsPerPage: 10, recordIndex: 1, })
      this.tableLoading = false
    } ,
    async pagination(e){
      if (this.storeSearchResults.length == 0) return
      this.tableLoading = true
      let index = ( e.page * e.itemsPerPage ) - e.itemsPerPage + 1
      await this.$store.dispatch('pretailer/SEARCH_STORE', { recordsPerPage: e.itemsPerPage, recordIndex: index })
      this.tableLoading = false
    },
    async rowClick(e, {item}){
      this.newStore = false
      this.$store.dispatch('pretailer/RESET_STORE')
      this.selectedStore = item.ID
      await this.$store.dispatch('pretailer/GET_STORE', item.ID )
      this.storeDialog = true
    },
    async insertUpdateStore(){
      if ( this.$refs.storeForm.validate() ){
        if (this.newStore){
          await this.$store.dispatch('pretailer/CHECK_FOR_DUPLICATE', 'INSERT_STORE')
          this.newStore = false   //This is assuming the store has been added and forces updates over inserts.
        } else {
          this.selectedStore = this.$store.state.pretailer.storeInfo.ID
          await this.$store.dispatch('pretailer/CHECK_FOR_DUPLICATE', 'UPDATE_STORE')
          this.$store.dispatch('pretailer/RESET_STORE')
          await this.$store.dispatch('pretailer/GET_STORE', this.selectedStore )
        }
      }
    },
    async searchSite(){
      await this.$store.dispatch('pretailer/SEARCH_SITE')
    },
    async siteCheckboxClick(item){
      const status = function(){
        if (item.IsAttachedToSite == false) return 1
        return 901
      }
      await this.$store.dispatch('pretailer/ATTACH_DETACH_SITE', { siteIDs: item.ID, rowStatusTypeID: status() })
    },
    async saveUpdatePretailer(){
      this.activeTab = 'pretailer'
      setTimeout( async() => { //to have form validation work properly with tabs setting timeout
        if(this.$refs.pretailerForm.validate()) {
          if (this.id == 0){
            await this.$store.dispatch('pretailer/INSERT_PRETAILER')
            this.$router.push({name: 'Pretailer', params: { id: this.pretailerInfo.ID }})
          } else {
            await this.$store.dispatch('pretailer/UPDATE_PRETAILER')
          }
        }
      }, 100)
    },
    formatNum(e){
      const input = e.target.value.replace(/\D/g,'').substring(0,10)
      const areaCode = input.substring(0,3)
      const middle = input.substring(3,6)
      const last = input.substring(6,10)
      if(input.length > 6){e.target.value = `${areaCode}-${middle}-${last}`}
      else if(input.length > 3){e.target.value = `${areaCode}-${middle}`}
      else if(input.length > 0){e.target.value = `${areaCode}`}
    },
    async countryUpdate(e){
      await this.$store.dispatch('merchant/GET_STATES', e)
    }    
  }
}
</script>

<template>
  <v-container fluid>

    <v-row>
      <router-link style="text-decoration: none" class="px-5 pt-5" :to="{ name: 'Merchant', params: { id: pretailerInfo.MerchantID } }"> 
        Merchant: {{ pretailerInfo.MerchantName }} ({{ pretailerInfo.MerchantID }})
      </router-link>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-tabs show-arrows right grow>
          <v-tab @click="activeTab = 'pretailer'">Pretailer Attributes</v-tab>
          <v-tab @click="activeTab = 'homePageLogo'">Home Page Logo</v-tab>
          <v-tab @click="activeTab = 'logoInformation'">Logo Information</v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <v-form ref="pretailerForm">
      <v-row align="center" v-if="activeTab == 'pretailer'">
        <v-col cols="12" sm="3">
          PRetailerID <br/> {{ id }}
        </v-col>
        <v-col cols="12" sm="3">
          Row Status Type <br/> <span :class="{ 'green--text font-weight-black': pretailerInfo.RowStatus == 1 || pretailerInfo.RowStatus == undefined }">{{ getRowStatus }}</span>
        </v-col>
        <v-col cols="12" sm="3">
          Last Updated By <br/> {{ pretailerInfo.LastUpdatedBy }}
        </v-col>
        <v-col cols="12" sm="3">
          Last Updated Date <br/> {{ pretailerInfo.LastUpdateDate }}
        </v-col>
        <v-col cols="12" sm="4">
          <InputWithObj :rules="[...required]" form="pretailer" field="pretailerInfo" objkey="Name" label="PRetailer Name" />
        </v-col>
        <v-col cols="12" sm="4">
          <InputWithObj :rules="[...optionalNumbersRule]" form="pretailer" field="pretailerInfo" objkey="Rating" label="Pretailer Rating" />
        </v-col>
        <v-col cols="12" sm="4">
          <CheckboxWithObj form="pretailer" field="pretailerInfo" objkey="AcceptsInStoreReturnsFlag" ifTrue="Y" ifFalse="N" label="Accepts In Store Returns" />
        </v-col>
        <v-col cols="12" sm="4">
          <InputWithObj form="pretailer" field="pretailerInfo" objkey="ThirdPartyVerificationInfo" label="Third Party Verification Info" />
        </v-col>
        <v-col cols="12" sm="4">
          <InputWithObj form="pretailer" field="pretailerInfo" objkey="URL" label="Pretailer URL" />
        </v-col>
        <v-col cols="12" sm="4">
          <Select form="pretailer" :rules="[...required]" field="pretailerInfo" objkey="TypeID" :items="pretailerTypes" label="Pretailer Type" />
        </v-col>
      </v-row>
      <v-row v-if="activeTab == 'homePageLogo'">
        <v-col cols="12" sm="4">
          <InputWithObj :rules="[...optionalNumbersRule]" form="pretailer" field="pretailerInfo" objkey="HomePageLogoHeight" label="Height" />
        </v-col>
        <v-col cols="12" sm="4">
          <InputWithObj :rules="[...optionalNumbersRule]" form="pretailer" field="pretailerInfo" objkey="HomePageLogoWidth" label="Width" />
        </v-col>
        <v-col cols="12" sm="4">
          <InputWithObj form="pretailer" field="pretailerInfo" objkey="HomePageLogoLocation" label="Location" />
        </v-col>
      </v-row>
      <v-row v-if="activeTab == 'logoInformation'">
        <v-col cols="12" sm="4">
          <InputWithObj :rules="[...optionalNumbersRule]" form="pretailer" field="pretailerInfo" objkey="LogoHeight" label="Height" />
        </v-col>
        <v-col cols="12" sm="4">
          <InputWithObj :rules="[...optionalNumbersRule]" form="pretailer" field="pretailerInfo" objkey="LogoWidth" label="Width" />
        </v-col>
        <v-col cols="12" sm="4">
          <InputWithObj form="pretailer" field="pretailerInfo" objkey="LogoLocation" label="Location" />
        </v-col>
        <v-col cols="12" sm="4">
          <InputWithObj :rules="[...optionalNumbersRule]" form="pretailer" field="pretailerInfo" objkey="LogoThumbHeight" label="Thumb Height" />
        </v-col>
        <v-col cols="12" sm="4">
          <InputWithObj :rules="[...optionalNumbersRule]" form="pretailer" field="pretailerInfo" objkey="LogoThumbWidth" label="Thumb Width" />
        </v-col>
        <v-col cols="12" sm="4">
          <InputWithObj form="pretailer" field="pretailerInfo" objkey="LogoThumbLocation" label="Thumb Location" />
        </v-col>
        <v-col cols="12" sm="6">
          <InputWithObj form="pretailer" field="pretailerInfo" objkey="LogoAltTag" label="Alt Tag" />
        </v-col>
        <v-col cols="12" sm="6">
          <InputWithObj form="pretailer" field="pretailerInfo" objkey="LogoThumbAltTag" label="Thumb Alt Tag" />
        </v-col>
      </v-row>
    </v-form>
    <v-row class="py-4" justify="space-around">
      <v-btn @click="siteDialog = true" class="mb-2" color="primary">Site Search</v-btn>
      <v-btn :to="{ name: 'MSG Search', params: { id: pretailerInfo.RetailerID, pretailerId: pretailerInfo.ID, storeId: 0 }}" class="mb-2" color="primary">MSG Search</v-btn>
      <v-btn class="mb-2" @click="saveUpdatePretailer" :disabled="!$store.getters['pretailer/pretailerChanged']" width="125px" color="primary"><v-icon left>mdi-content-save</v-icon>Save</v-btn>
    </v-row>
    <v-divider/>
    <div v-if="id != 0">
      <v-row class="pa-5">
        <h2 class="primary--text">Store Search</h2>
      </v-row>
      <v-row>
        <v-col class="py-0" cols="12">
          <p class="d-flex justify-center primary--text">To search all stores leave "Search By" empty and "Criteria" can be set to any option</p>
        </v-col>
        <v-col class="pb-0" cols="12" sm="6">
          <Input :disabled="disableSearch" form="pretailer" :field="$store.state.pretailer.storeSearchCriteria" :maxlength="128" placeholder="" label="Search By" />
        </v-col>
        <v-col class="pb-0" cols="12" sm="6">
          <AutocompleteSelect form="pretailer" field="storeSearchCriteria" placeholder="" label="Criteria" :items="searchCriteriaItems" />
        </v-col>
        <v-col class="py-0" cols="12" sm="3">
          <Input :disabled="disableCity" form="pretailer" field="citySearch" :maxlength="128" placeholder="" label="City (Optional)"/>
        </v-col>
        <v-col class="py-0" cols="12" sm="3">
          <AutocompleteSelect :disabled="disableState" form="pretailer" field="storeSearchState" placeholder="" label="State" :items="statesItems" />
        </v-col>
        <v-col class="py-0" cols="12" sm="3">
          <Select :disabled="disableCountry" form="pretailer" field="storeSearchCounty" placeholder="" label="Countries" :items="countriesItems" @change="countryUpdate" />
        </v-col>
        <v-col class="py-0" cols="12" sm="3">
          <AutocompleteSelect :disabled="disableStatus" form="pretailer" field="storeSearchStatus" placeholder="" label="Status" :items="statusDropdown" />
        </v-col>
      </v-row>
      <v-row class="px-5" justify="end">
        <v-btn @click="newStoreBtn" color="primary"><v-icon left>mdi-plus-box</v-icon>Create New Store</v-btn>
        <v-btn @click="searchStore" class="ml-2" color="primary">Search<v-icon right>mdi-magnify</v-icon></v-btn>
      </v-row>
      <v-row>
        <v-col cols="12">
          <p class="d-flex justify-center primary--text">Double click Row to edit Store</p>
          <v-data-table
            :headers="headers()"
            :items="storeSearchResults"
            :loading="tableLoading"
            :server-items-length="$store.state.pretailer.totalOnServer"
            :footer-props="{ 'items-per-page-options': [ 10, 25 , 50], 'show-first-last-page': true } "
            @update:options="pagination"
            @dblclick:row="rowClick"
          >
            <template v-slot:item.RowStatus=" { item }" >
              <span>
                {{ getTabelRowStatus( item.RowStatus ) }}
              </span>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-dialog persistent v-model="storeDialog" fullscreen>
        <v-card>
          <v-card-text class="pt-1 pb-0">
            <v-form ref="storeForm">
              <v-row justify="center">
                <v-col cols="12" sm="4">
                  <v-row>
                    <v-col cols="12">
                      <h1 class="py-1 primary--text">Store Attribute</h1> 
                    </v-col>
                  </v-row>
                  <v-row class="py-1">
                    <v-col cols="12" sm="6">
                      storeID: {{ $store.state.pretailer.storeInfo.ID }} 
                    </v-col>
                    <v-col cols="12" sm="6">
                      Row Status: <span :class="{ 'green--text font-weight-black': $store.state.pretailer.storeInfo.RowStatus == 1 || $store.state.pretailer.storeInfo.RowStatus == undefined}">{{ getTabelRowStatus($store.state.pretailer.storeInfo.RowStatus) }}</span>
                    </v-col>
                  </v-row>
                  <Select dense form="pretailer" :rules="[...required]" field="storeInfo" objkey="PRetailerID" :items="pretailerByRetailer" label="Pretailer" />
                  <Select dense multiple form="pretailer" field="storeInfo" objkey="DisplayLang" :items="allLanguagesItems" label="Language" />
                  <InputWithObj dense :rules="[...required]" form="pretailer" field="storeInfo" objkey="Reference" label="Store Reference" />
                  <InputWithObj dense :rules="[...required]" form="pretailer" field="storeInfo" objkey="Name" label="Store Name" />
                  <InputWithObj dense :rules="[...required]" form="pretailer" field="storeInfo" objkey="Address1" label="Address 1" />
                  <InputWithObj dense form="pretailer" field="storeInfo" objkey="Address2" label="Address 2" />
                  <InputWithObj dense form="pretailer" field="storeInfo" objkey="Address3" label="Address 3" />
                  <InputWithObj dense :rules="[...required]" form="pretailer" field="storeInfo" objkey="City" label="City" />
                  <v-row>
                    <v-col class="py-0" cols="12" sm="6">
                      <Select dense form="pretailer" :rules="[...required]" field="storeInfo" objkey="State" :items="statesItems" label="State/Province" />
                    </v-col>
                    <v-col class="py-0" cols="12" sm="6">
                      <InputWithObj dense :rules="[...required]" form="pretailer" field="storeInfo" objkey="ZipCode5" label="Zip Code/Postal Code" />
                    </v-col>
                  </v-row>
                  <Select dense form="pretailer" :rules="[...required]" field="storeInfo" objkey="CountryID" :items="countriesItems" label="Country" />
                  Last Updated By: {{ $store.state.pretailer.storeInfo.LastUpdatedBy }} <br/>
                  Last Updated Date: {{ $store.state.pretailer.storeInfo.LastUpdateDate }}
                </v-col>
                <v-col cols="12" sm="4">
                  <Select dense form="pretailer" :rules="[...required]" field="storeInfo" objkey="DataSourceTypeID" :items="dataSourceTypes" label="Data Source Type" />
                  <InputWithObj dense :rules="[...required]" form="pretailer" field="storeInfo" objkey="DataSourceKey" label="Data Source Key" />
                  <InputWithObj dense form="pretailer" field="storeInfo" objkey="DataSourceStoreName" label="Data Source Name" />
                  <v-row>
                    <v-col class="py-0" cols="12" sm="6">
                      <InputWithObj dense form="pretailer" field="storeInfo" objkey="MallName" label="Mail Name" />
                    </v-col>
                    <v-col class="py-0" cols="12" sm="6">
                      <InputWithObj dense form="pretailer" field="storeInfo" objkey="ManagerName" label="Manager Name" />
                    </v-col>
                  </v-row>
                  <InputWithObj dense form="pretailer" field="storeInfo" objkey="URL" label="URL" />
                  <v-row>
                    <v-col @keyup="formatNum" class="py-0" cols="12">
                      <InputWithObj dense :maxlength="12" form="pretailer" field="storeInfo" objkey="DisplayPhoneNumber" label="Store Phone Number" />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col @keyup="formatNum" class="py-0" cols="12" sm="6">
                      <InputWithObj dense :maxlength="12" form="pretailer" field="storeInfo" objkey="DisplayFaxNumber" label="Store Fax Number" />
                    </v-col>
                    <v-col @keyup="formatNum" class="py-0" cols="12" sm="6">
                      <InputWithObj dense :maxlength="12" form="pretailer" field="storeInfo" objkey="DisplayRxNumber" label="Pharmacy Number" />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="py-0" cols="12" sm="6">
                      <InputWithObj dense form="pretailer" field="storeInfo" objkey="Latitude" label="Latitude Radians" />
                    </v-col>
                    <v-col class="py-0" cols="12" sm="6">
                      <InputWithObj dense form="pretailer" field="storeInfo" objkey="Longitude" label="Longitude Radians" />
                    </v-col>
                  </v-row>
                  <InputWithObj dense form="pretailer" field="storeInfo" objkey="GeoCodeStatus" label="Geo Code Status" />
                  <TextareaObj dense form="pretailer" field="storeInfo" objkey="Hours" label="Store Hours" />
                  <v-row>
                    <v-col class="py-0" cols="12" sm="6">
                      <InputWithObj dense form="pretailer" field="storeInfo" objkey="OpenDate" label="Store Open Date" :rules="[...optionalDate]"/>
                    </v-col>
                    <v-col class="py-0" cols="12" sm="6">
                      <InputWithObj dense form="pretailer" field="storeInfo" objkey="CloseDate" label="Store Close Date" :rules="[...optionalDate]"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="px-5 pt-0 pb-5" >
            <v-row justify="center">
              <v-col class="py-0 d-flex justify-start" cols="12" sm="3">
                <v-btn :disabled="$store.state.pretailer.storeInfo.ID == 0" class="mx-1" width="150" color="primary" :to="{ name: 'MSG Search', params: { id: pretailerInfo.RetailerID, pretailerId: pretailerInfo.ID, storeId: $store.state.pretailer.storeInfo.ID }}">MSG Search</v-btn>
              </v-col>
              <v-col class="py-0 d-flex justify-end" cols="12" sm="5">
                <v-btn class="mx-1" width="125" color="secondary" @click="storeDialog = false">close</v-btn>
                <v-btn class="mx-1" width="125" color="primary" @click="insertUpdateStore" ><v-icon left>mdi-content-save</v-icon>save</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="siteDialog" fullscreen>
        <v-card>
          <v-card-title class="primary--text">
            Site Search
          </v-card-title>
          <v-card-text>
            <v-row justify="center">
              <v-col class="py-0" cols="12" sm="6">
                <AutocompleteSelect form="pretailer" field="siteSearch" placeholder="" label="Site Type" :items="siteTypeItems" />
              </v-col>
              <v-col cols="12" sm="2">
                <v-btn width="100%" @click="searchSite" color="primary">Search</v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="siteSearchHeaders()"
                  :items="siteSearchResults"
                  :items-per-page="10"
                  :footer-props="{ 'items-per-page-options': [ 10, 15,  25 , -1] } "
                  multi-sort
                  sort-by="IsAttachedToSite"
                  sort-desc
                >
                  <template v-slot:item.IsAttachedToSite=" { item }" >
                    <span>
                      <v-simple-checkbox 
                        @click.capture="siteCheckboxClick(item)"
                        color="primary"
                        :ripple="false"
                        :value="item.IsAttachedToSite"
                      ></v-simple-checkbox>
                    </span>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="d-flex justify-end px-5 pb-5" >
            <v-btn class="mx-1" width="125" color="secondary" @click="siteDialog = false">close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>
